 'use client';

import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { Product } from '@/components/features/product/product.types';

interface ProductImagesProps {
  product: Product;
}

export function ProductImages({ product }: ProductImagesProps) {
  const images = [
    product.WDCatalogImage,
    product.Image1,
    product.Image2,
    product.Image3,
    product.Image4,
  ].filter(Boolean);

  const fileNames = [
    product.WDCatalogImageFileName,
    product.Image1FileName,
    product.Image2FileName,
    product.Image3FileName,
    product.Image4FileName,
  ].filter(Boolean);

  if (images.length === 0) return null;

  return (
    <TabGroup as="div" className="flex flex-col-reverse">
      <div className="hidden mt-6 w-full max-w-2xl mx-auto sm:block lg:max-w-none">
        <TabList className="grid grid-cols-4 gap-6">
          {images.map((image, idx) => (
            <Tab
              key={idx}
              className="relative h-24 bg-white rounded-md flex items-center justify-center text-sm font-medium uppercase text-gray-900 cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring focus:ring-offset-4 focus:ring-opacity-50"
            >
              {({ selected }) => (
                <>
                  <span className="sr-only">{product.eCommerceStoreName}</span>
                  <span className="absolute inset-0 rounded-md overflow-hidden">
                    <img
                      src={`data:image/${fileNames[idx].split('.').pop()};base64,${image}`}
                      alt=""
                      className="w-full h-full object-center object-cover"
                    />
                  </span>
                  <span
                    className={`${
                      selected ? 'ring-indigo-500' : 'ring-transparent'
                    } absolute inset-0 rounded-md ring-2 ring-offset-2 pointer-events-none`}
                    aria-hidden="true"
                  />
                </>
              )}
            </Tab>
          ))}
        </TabList>
      </div>

      <TabPanels className="w-full aspect-w-1 aspect-h-1">
        {images.map((image, idx) => (
          <TabPanel key={idx}>
            <img
              src={`data:image/${fileNames[idx].split('.').pop()};base64,${image}`}
              alt={product.eCommerceStoreName}
              className="w-full h-full object-center object-cover sm:rounded-lg"
            />
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
}